/**
 * Under a board row's schedule: how many of its drop times fall outside the
 * country's window — amber when they will not go (the window is a hard
 * limit), muted when the container or the drop lets them go anyway.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Moon } from 'lucide-react';

import { cn } from '@/lib/utils';

import type { OutsideCount } from '../../../utils/drops/outside-window';

const times = (n: number) => `${n} time${n === 1 ? '' : 's'}`;

function words(o: OutsideCount): { text: string; title: string; cut: boolean } | null {
  if (o.cut > 0) {
    const all = o.cut === o.total;
    return {
      cut: true,
      text: all ? 'all outside the window' : `${times(o.cut)} outside the window`,
      title: `${all ? 'Every drop time' : `${times(o.cut)} of ${o.total}`} of this container fall outside the country's window — not sent (the window is a hard limit). Move its start in Schedule, widen the window (click the Window at the top), or let them go: Schedule › Outside the window.`,
    };
  }
  if (o.sent > 0)
    return { cut: false, text: `${times(o.sent)} sent outside the window`, title: 'Outside the window on purpose — this container (or the drop) lets them go: Schedule › Outside the window.' };
  return null;
}

export const OutsideWindowMark: FC<{ outside: OutsideCount }> = ({ outside }) => {
  const w = words(outside);
  if (!w) return null;
  return (
    <span className={cn('flex items-center gap-1 text-[10px] font-medium', w.cut ? 'text-warning' : 'text-muted-foreground')} title={w.title} data-testid="outside-window-mark">
      <Moon className="h-3 w-3 shrink-0" aria-hidden />
      <span className="truncate">{w.text}</span>
    </span>
  );
};
